import React from 'react'
import LabeledSelect from '../../../components/selects/LabeledSelect'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'
import { getActiveNurses } from '../../../redux/slices/nurseCampaignSlice'
import JobCardLoader from './JobCardLoader'
import Chip from 'components/form/Chip'
import {differenceWith , isEqual} from 'lodash';

const AssignOrder = ({ setSelectedNurses, ModalOptions, selectedNurses }) => {
  const dispatch = useDispatch()
  const { nurses, nurseListError, loadingNurseList } = useSelector(
    (state) => state.campaign,
  )

  return (
    <div>
      {!isEmpty(nurseListError) || loadingNurseList || isEmpty(nurses) ? (
        <JobCardLoader
          count={1}
          height="h-10"
          loading={loadingNurseList}
          error={nurseListError}
          isEmpty={isEmpty(nurses)}
          retry={() => {
            dispatch(getActiveNurses())
          }}
        />
      ) : (
        <div>
          <div className="flex flex-wrap mb-5">
            {selectedNurses.map((selectedNurse) => (
              <Chip
                key={selectedNurse.id}
                label={`${selectedNurse.first_name} ${selectedNurse.last_name}`}
                onClick={() => {
                  let filtered = selectedNurses.filter((nurse) => nurse.id !== selectedNurse.id)
                  setSelectedNurses(filtered)
                }}
              />
            ))}
          </div>
          <LabeledSelect
            placeholder="Select Nurse..."
            onChange={(nurse) => {
              setSelectedNurses([...selectedNurses, nurse])
              ModalOptions.assignOrder.selectedNurses = [
                ...ModalOptions.assignOrder.selectedNurses,
                nurse,
              ]
            }}
            options={differenceWith(nurses, selectedNurses, !isEqual)}
            getOptionValue={(option) =>
              `${option?.first_name ?? ''} ${option?.last_name ?? ''}`
            }
            getOptionLabel={(option) =>
              `${option?.first_name} ${option?.last_name}`
            }
            value={ModalOptions.assignOrder.selectedNurse}
          />
        </div>
      )}
    </div>
  )
}

export default AssignOrder
